up.compiler('[submit-actions-modal]', (element, data) => {

  const formId = data.formId
  const fieldName = data.fieldName
  const fieldValue = '1'
  const form = document.getElementById(formId)

  function saveWithNotification() {
    const input = up.element.createFromSelector('input', { type: 'hidden', name: fieldName, value: fieldValue })
    form.appendChild(input)
    save()
  }

  function save() {
    up.layer.dismiss()
    up.submit(form).catch(function(error) {
      console.log(error); // unpoly prints a 'Uncaught (in promise)' error to the console when form round trip fails, which breaks tests
    });

  }

  element.querySelector('[save-with-notification]').addEventListener('click', saveWithNotification)
  element.querySelector('[save-without-notification]').addEventListener('click', save)

})
